import cashClosureApi from "../../api/cash/cashClosureApi";

const CashClosureService = {

    /**
     * ▶️ Iniciar cierre
     * POST /api/cash/closures/start
     */
    start: async () => {

        const response = await cashClosureApi.addCustom("/start", {});
        return response.data;

    },

    /**
     * 🔎 Obtener cierre activo
     * GET /api/cash/closures/active
     */
    getActive: async () => {

        const response = await cashClosureApi.fetchCustom("/active");
        return response.data;

    },

    /**
     * ✅ Finalizar cierre
     * POST /api/cash/closures/{id}/complete
     */
    complete: async (id: number, data: any) => {

        const response = await cashClosureApi.addCustom(`/${id}/complete`, data);
        return response.data;

    },

    /**
     * 📊 Último cierre
     * GET /api/cash/closures/last
     */
    getLast: async () => {

        const response = await cashClosureApi.fetchCustom("/last");
        return response.data;

    },

    /**
     * 📊 Reporte de Corte Z de un cierre (histórico o activo)
     * GET /api/cash/closures/{id}/report
     */
    getReport: async (id: number) => {

        const response = await cashClosureApi.fetchCustom(`/${id}/report`);
        return response.data;

    }

};

export default CashClosureService;